import { createContext } from 'react'
import { Socket } from 'socket.io-client'

type SocketConnectionType = {
  socket: Socket | null
}

const defaultValues = {
  socket: null,
}

const SocketConnectionManager = createContext<SocketConnectionType>(defaultValues)

export default SocketConnectionManager
